<body class="dashboard dashboard-bg superadmin-dashboard">

  <app-header></app-header>

  <div class="body-container collapsed">
    <app-sidebar></app-sidebar>

    <div class="body-content">
      <div class="row">
        <div class="col-md-8 p-0">
          <app-page-header [title]="'Sensors' | translate" iconClass="fas fa-broadcast-tower"></app-page-header>
        </div>

        <div class="col-md-4 p-0">
          <div class="text-right grid-button-container">
            <button type="button" class="btn button-primary" (click)="add()" mat-button>
              Add Sensor
            </button>
          </div>
        </div>
      </div>

      <app-progress-spinner [show]="isLoading || (dataSource.isLoading$ | async)"></app-progress-spinner>

      <div class="white-box">
        <mat-form-field>
          <mat-label>{{ 'Search' | translate }}</mat-label>
          <input matInput #searchField />
          <mat-icon matPrefix class="mr-3">
            <i class="fas fa-search"></i>
          </mat-icon>
        </mat-form-field>

        <table mat-table [dataSource]="dataSource" matSort matSortActive="Tenant.Name" matSortDirection="asc"
          matSortDisableClear>

          <ng-container matColumnDef="Tenant.Name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Tenant' | translate }}</th>
            <td mat-cell *matCellDef="let sensor">{{sensor.tenantName}}</td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Device Name' | translate }}</th>
            <td mat-cell *matCellDef="let sensor">
              <div class="grid-link" (click)="setSensorId(sensor)">
                {{sensor.name}}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Device ID' | translate }}</th>
            <td mat-cell *matCellDef="let sensor">{{sensor.id}}</td>
          </ng-container>

          <ng-container matColumnDef="DeviceVersion.Version">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Device Version' | translate }}</th>
            <td mat-cell *matCellDef="let sensor">{{sensor.deviceVersion}}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Status' | translate }}</th>
            <td mat-cell *matCellDef="let sensor">
              @if (sensor.status) {
                <mat-icon [title]="'Enabled' | translate">
                  <i class="fas fa-check-circle color-secondary"></i>
                </mat-icon>
              }
              @if (!sensor.status) {
                <mat-icon [title]="'Disabled' | translate">
                  <i class="fas fa-minus-circle color-accent"></i>
                </mat-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="imeI_No">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'IMEI No' | translate }}</th>
            <td mat-cell *matCellDef="let sensor">{{sensor.imeI_No}}</td>
          </ng-container>

          <ng-container matColumnDef="latitude">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Latitude' | translate }}</th>
            <td mat-cell *matCellDef="let sensor">{{sensor.latitude}}</td>
          </ng-container>

          <ng-container matColumnDef="longitude">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Longitude' | translate }}</th>
            <td mat-cell *matCellDef="let sensor">{{sensor.longitude}}</td>
          </ng-container>

          <ng-container matColumnDef="installationDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Installed' | translate }}</th>
            <td mat-cell *matCellDef="let sensor">{{sensor.installationDate | dateFormat}}</td>
          </ng-container>

          <ng-container matColumnDef="gpsCapability">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GPS Capability' | translate }}</th>
            <td mat-cell *matCellDef="let sensor">
              @if (sensor.gpsCapability) {
                <mat-icon [title]="'Enabled' | translate">
                  <i class="fas fa-check-circle color-secondary"></i>
                </mat-icon>
              }
              @if (!sensor.gpsCapability) {
                <mat-icon [title]="'Disabled' | translate">
                  <i class="fas fa-minus-circle color-accent"></i>
                </mat-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="tableNames">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Table Names' | translate }}</th>
            <td mat-cell *matCellDef="let sensor">{{sensor.tableNames.join(', ')}}</td>
          </ng-container>

          <ng-container matColumnDef="videoCapability">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Video Capability' | translate }}</th>
            <td mat-cell *matCellDef="let sensor">
              @if (sensor.videoCapability) {
                <mat-icon [title]="'Enabled' | translate">
                  <i class="fas fa-check-circle color-secondary"></i>
                </mat-icon>
              }
              @if (!sensor.videoCapability) {
                <mat-icon [title]="'Disabled' | translate">
                  <i class="fas fa-minus-circle color-accent"></i>
                </mat-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="density">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Density' | translate }}</th>
            <td mat-cell *matCellDef="let sensor">{{sensor.density}}</td>
          </ng-container>

          <ng-container matColumnDef="configurationCapability">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Configuration Capability' | translate }}</th>
            <td mat-cell *matCellDef="let sensor">
              @if (sensor.configurationCapability) {
                <mat-icon [title]="'Enabled' | translate">
                  <i class="fas fa-check-circle color-secondary"></i>
                </mat-icon>
              }
              @if (!sensor.configurationCapability) {
                <mat-icon [title]="'Disabled' | translate">
                  <i class="fas fa-minus-circle color-accent"></i>
                </mat-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th class="action-column" mat-header-cell *matHeaderCellDef>{{ 'Action' | translate }}</th>
            <td class="action-column" mat-cell *matCellDef="let sensor">
              <mat-icon class="action-icon" [title]="'Edit' | translate" (click)="edit(sensor)">
                <i class="fas fa-edit"></i>
              </mat-icon>

              @if (sensor.configurationCapability) {
                <mat-icon class="action-icon color-primary-light" [title]="'Configure' | translate" (click)="configure(sensor)">
                  <i class="fas fa-cog"></i>
                </mat-icon>
              }

              <mat-icon class="action-icon color-accent" [title]="'Delete' | translate" (click)="delete(sensor)">
                <i class="fas fa-trash"></i>
              </mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;"
          [class.even-row]="even"></tr>
        </table>

        <mat-paginator [length]="dataSource.count$ | async" [pageSizeOptions]="[5, 10, 20]" [pageSize]="10"
        showFirstLastButtons></mat-paginator>
      </div>

      <div class="row">
        <div class="col-lg-3 offset-lg-9">
          <mat-form-field>
            <mat-label>{{ 'Time Zone' | translate }}</mat-label>
            <input matInput [(ngModel)]="timeZoneLabel" readonly />
            <mat-icon matPrefix class="mr-3">
              <i class="fas fa-globe"></i>
            </mat-icon>
          </mat-form-field>
        </div>
      </div>

      <div class="clearfix"></div>
      <app-footer></app-footer>
    </div>

    <div class="clearfix"></div>
  </div>
</body>
